<template>
    <component
        :is="clickable ? 'button' : 'div'"
        :type="clickable ? 'button' : null"
        class="empty-state"
        :class="{'is-clickable': clickable, 'is-locked': locked, 'is-compact': compact}"
        @click="onClick"
    >
        <span class="empty-state__icon"><i class="ki-filled" :class="icon"></i></span>
        <div class="empty-state__title">{{ title }}</div>
        <p v-if="text" class="empty-state__text">{{ text }}</p>
        <div v-if="$slots.default" class="empty-state__action" @click.stop><slot/></div>
    </component>
</template>

<script>
export default {
    name: 'EmptyState',
    props: {
        icon: {type: String, default: 'ki-information-2'},
        title: {type: String, default: ''},
        text: {type: String, default: ''},
        clickable: {type: Boolean, default: false},
        locked: {type: Boolean, default: false},
        compact: {type: Boolean, default: false},
    },
    emits: ['click'],
    methods: {
        onClick() {
            if (this.clickable) this.$emit('click')
        },
    },
}
</script>

<style scoped>
.empty-state {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: .35rem;
    padding: 2.75rem 1.25rem;
    border: 2px dashed var(--color-border);
    border-radius: .85rem;
    background: color-mix(in oklch, var(--color-secondary-foreground) 4%, transparent);
    transition: border-color .15s ease, background .15s ease;
    color: inherit;
}
.empty-state.is-compact { padding: 1.75rem 1rem; }
.empty-state.is-clickable { cursor: pointer; }
.empty-state.is-clickable:hover {
    border-color: var(--color-primary);
    background: color-mix(in oklch, var(--color-primary) 5%, transparent);
}
.empty-state.is-locked { opacity: .9; }
.empty-state__icon {
    width: 3.5rem;
    height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: color-mix(in oklch, var(--color-primary) 12%, transparent);
    color: var(--color-primary);
    font-size: 1.5rem;
    margin-bottom: .35rem;
}
.empty-state.is-compact .empty-state__icon { width: 2.75rem; height: 2.75rem; font-size: 1.15rem; }
.empty-state.is-locked .empty-state__icon {
    background: color-mix(in oklch, var(--color-secondary-foreground) 12%, transparent);
    color: var(--color-muted-foreground);
}
.empty-state__title { font-size: .875rem; font-weight: 600; color: var(--color-mono); }
.empty-state__text { font-size: .75rem; color: var(--color-muted-foreground); max-width: 340px; line-height: 1.5; margin: 0; }
.empty-state__action { margin-top: .65rem; }
</style>
